<!--
 * @Author: Gaho
 * @Date: 2024-02-26 13:46:41
 * @LastEditors: Gaho
 * @LastEditTime: 2025-02-10 17:03:59
 * @Description: 
-->
<template>
    <div class="card-bg">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            class="background-gradient"
            viewBox="0 0 161 159"
        >
            <rect width="161" height="159" fill="#5638B2" fill-opacity=".45" rx="14"></rect>
            <g><circle cx="50%" cy="50%" r="64" fill="currentColor" filter="url(#abc)"></circle></g>
            <defs>
                <filter
                    id="abc"
                    width="159.635"
                    height="158.222"
                    x=".6825"
                    y=".6825"
                    color-interpolation-filters="sRGB"
                    filterUnits="userSpaceOnUse"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                    <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
                    <feGaussianBlur stdDeviation="17.6587"></feGaussianBlur>
                </filter>
            </defs>
        </svg>
        <img src="@/assets/imgs/casino/corgiwild/triple-bar.webp" class="card-triple-img" alt="" />
        <img src="@/assets/imgs/casino/corgiwild/triple-bar.webp" class="card-triple-img" alt="" />
        <img src="@/assets/imgs/casino/corgiwild/triple-bar.webp" class="card-triple-img" alt="" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'corgiwild-card-triple',
});
</script>
<style lang="scss" scoped>
.card-bg {
    svg {
        color: #ff5309 !important;
    }
    .card-triple-img {
        left: 50%;
        position: absolute;
        top: 26%;
        transform: translate(-45%, -45%) scale(1);
        z-index: 2;
        width: 100%;
        @media (max-width: 576px) {
            width: 65px;
        }
        &:nth-child(2) {
            animation-delay: 0.3s !important;
            top: 53%;
        }
        &:nth-child(3) {
            animation-delay: 0.6s !important;
            top: 79%;
            @media (max-width: 576px) {
                top: 80%;
            }
        }
    }
}
</style>
